import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'hourOrDay'
})
export class HourOrDayPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (Number.isInteger(value)) {
      if (value >= 24) {
        const day = value / 24;
        return (day === 1) ? day + ' day' : day + ' days';
      } else {
        return value + ' hr';
      }
    }
    return 0;
  }

}
